import { TreeSelect } from '@/ui/Select'
import { useGarageStore } from '../store'
import { useGetGarages } from '../api/useGetGarages'

export const GarageSelect = () => {
    const { data: garages } = useGetGarages()
    const { garage, setGarage, setSelectedRoutes } = useGarageStore()

    const options =
        garages
            ?.slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((g) => ({ value: g.shortCode, label: g.name })) ?? []

    const handleChange = (value: string) => {
        const selected = garages?.find((g) => g.shortCode === value)
        if (selected) {
            setGarage(selected)
            setSelectedRoutes(selected.routes)
        }
    }

    return (
        <TreeSelect
            placeholder="Garages"
            options={options}
            value={garage?.shortCode}
            disabled={false}
            onChange={handleChange}
        />
    )
}
